import { render } from "./TabsQueryRouter.vue?vue&type=template&id=5d4d023d"
import script from "./TabsQueryRouter.vue?vue&type=script&lang=js"
export * from "./TabsQueryRouter.vue?vue&type=script&lang=js"
script.render = render

export default script